// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"81d7b6c2","455":"8848e51d","838":"8ea9787c","977":"042c8deb"}[chunkId] + ".chunk.js";
};